import { createSelector } from 'reselect';

const companySelector = (state) => state.companies;

export const getCurrentCompany = createSelector(
    companySelector,
    (companies) => companies.currentCompany
);

export const getCurrentCompanyId = createSelector(
    getCurrentCompany,
    (company) => company.firebaseId
);

export const getCurrentCompanyPlatform = createSelector(
    getCurrentCompany,
    (company) => company.platform || []
);

export const getAllCompanies = createSelector(
    companySelector,
    (companies) => companies.items
);



// WEBPACK FOOTER //
// ./src/containers/selectors/companySelectors.js